import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField,} from '@mui/material';

interface HesapModalProps {
    open: boolean;
    onClose: () => void;
    formik: any;
    kisiler: any[];
}

const HesapModal: React.FC<HesapModalProps> = ({open, onClose, formik, kisiler}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>{formik.values.id ? 'Hesap Düzenle' : 'Yeni Hesap Oluştur'}</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Hesap Adı"
                        name="hesapAdi"
                        value={formik.values.hesapAdi}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.hesapAdi && Boolean(formik.errors.hesapAdi)}
                        helperText={formik.touched.hesapAdi && formik.errors.hesapAdi}
                        sx={{mt: 2}}
                    />
                    <TextField
                        select
                        fullWidth
                        label="Hesap Tipi"
                        name="hesapTipi"
                        value={formik.values.hesapTipi}
                        onChange={formik.handleChange}
                        sx={{mt: 2}}
                    >
                        {['İşletme', 'Yönetici', 'Çalışan', 'Kredi', 'Kredi Kartı'].map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    {(formik.values.hesapTipi === 'Çalışan' || formik.values.hesapTipi === 'Yönetici') && (
                        <TextField
                            select
                            fullWidth
                            label="Kişi Seçin"
                            name="kisi_id"
                            value={formik.values.kisi_id}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.kisi_id && Boolean(formik.errors.kisi_id)}
                            helperText={formik.touched.kisi_id && formik.errors.kisi_id}
                            sx={{mt: 2}}
                        >
                            {kisiler.map((kisi: any) => (
                                <MenuItem key={kisi.id} value={kisi.id}>
                                    {kisi.isim} {kisi.soyisim} ({kisi.rumuz})
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                    <TextField
                        fullWidth
                        type="number"
                        label="Komisyon (%)"
                        name="komisyon"
                        value={formik.values.komisyon}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.komisyon && Boolean(formik.errors.komisyon)}
                        helperText={formik.touched.komisyon && formik.errors.komisyon}
                        sx={{mt: 2}}
                    />
                    <Stack direction="row" spacing={2} sx={{mt: 2}}>
                        <TextField
                            fullWidth
                            label="Aktif Başlangıç"
                            type="date"
                            name="aktif_baslangic"
                            InputLabelProps={{shrink: true}}
                            value={formik.values.aktif_baslangic || ''}
                            onChange={formik.handleChange}
                        />
                        <TextField
                            fullWidth
                            label="Aktif Bitiş"
                            type="date"
                            name="aktif_bitis"
                            InputLabelProps={{shrink: true}}
                            value={formik.values.aktif_bitis || ''}
                            onChange={formik.handleChange}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>İptal</Button>
                    <Button color="primary" type="submit">
                        Kaydet
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default HesapModal;
